<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <iframe :src="mData.dataDefault.links" width="100%" height="800px" frameborder="0"></iframe>
          </b-row>
          <el-form-item class="text-center mt-3">
            <!-- <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>-->

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import DangKyChuongTrinhModel from "./DangKyChuongTrinhModel";
// import ThanhTichHuyHieuApi from "../../../moduleApi/ThanhTichHuyHieuApi";
// import HuyHieuApi from "../../../moduleApi/HuyHieuApi";
// import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import ChuongTrinhApi from "../../../moduleApi/ChuongTrinhApi";
import DangKyChuongTrinhApi from "../../../moduleApi/DangKyChuongTrinhApi";
import AccountApi from "../../../moduleApi/AccountApi";
import SurveyApi from "../../../moduleApi/SurveyApi";
// import sha256 from "sha256/lib/sha256.js"

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "DangKyChuongTrinh",
        dataDefault: {
          roles: DataService.rolesInForm,
          links: "",
          iframe: {
            src: "",
            style: null,
            wrapperStyle: null,
          },
        },
        dataForm: MethodService.copyObject(DangKyChuongTrinhModel.dataForm),
        validForm: DangKyChuongTrinhModel.validForm,
        dialog: {},
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            // await DangKyChuongTrinhApi.create(this.mData.dataForm);
            // this.fn_resetForm();
            // this.fn_go(-1);
          }
          if (type == "update") {
            // this.mData.dataForm.id = this.$router.currentRoute.params.id;
            // await DangKyChuongTrinhApi.update(this.mData.dataForm);
            // this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DangKyChuongTrinhApi.findById(id);
      this.mData.dataForm = res.result;
      if (res.result) {
        let resChuongTrinh = await ChuongTrinhApi.findById(
          res.result.chuong_trinh_id
        );
        // let surveyPath=window.MyConfig.surveyCTEnv;
        // debugger;
        let findLinkSurvey = "";
        if (resChuongTrinh.result && resChuongTrinh.result.ap_dung) {
          findLinkSurvey = resChuongTrinh.result.ap_dung.find((element) => {
            return element.loai_doi_tuong == res.result.loai_doi_tuong;
          });
        }
        let surveyPath = findLinkSurvey ? findLinkSurvey.link_survey : "";

        let objJsonB64 = "";
        let prefillSurvey;
        if (res.result.du_lieu_khai_bao) {
          objJsonB64 = Buffer.from(
            JSON.stringify(res.result.du_lieu_khai_bao)
          ).toString("base64");
          prefillSurvey = await SurveyApi.getPrefillId({ data: objJsonB64 });
        }

        // let pathLocation =
        //   location.protocol + "//" + location.host + "/admin/DangKyChuongTrinh/success";
        let params = {
          prefillData: prefillSurvey.result,
          appCode: "Tourism",
          callbackUrl: "",
          env: window.MyConfig.envTourGuide,
        };
        let resCode = await AccountApi.generateHashCode(params);
        // console.log(resCode.result);
        // debugger;
        if (surveyPath != "") {
          this.mData.dataDefault.links = surveyPath.replace(/\{\w+\}/g, f => {
            switch(f) {
              case "{env}":
                return params.env;
              case "{appCode}":
                return params.appCode;
              case "{callbackUrl}":
                return params.callbackUrl;
              case "{prefillId}":
                return params.prefillData;
              case "{hashCode}":
                return resCode.result.toString().toLowerCase();
              default: 
                return "";
            }
          });
        }

        //tạo hashcode cứng
        // let obj = {
        //     privateKey: window.MyConfig.envTourGuide == 'dev_tourguide' ? "0>o0snb2sTp]EkojnIUSsrkC{1OsG_Jwh4_7ZXr21Rj5z35mVz)i8b44LJDkMtQz7DTtolo23oDVthWM]785m00[OT1>3qsgCQOk" : 'aS2cylXP5TwdOZOxZYeX9Fdp<lRNC)0FGRZlHyS3g>DuRQZzi96noX]R-b1XP([Ca7hcYCAgRdxjOJTeZpwsv_ZAZGW79Sy1{v5b',
        //     prefillData: objJsonB64,
        //     appCode: "Tourism",
        //     callbackUrl: "",
        //     env: window.MyConfig.envTourGuide
        // }
        // let hashCode = await sha256(obj.privateKey + "," + obj.prefillData + "," + obj.callbackUrl + "," + obj.appCode + "," + obj.env);
        // this.mData.dataDefault.links +=  window.MyConfig.surveyCTEnv+
        //   "prefillData=" +
        //   encodeURIComponent(objJsonB64) +
        //   "&hashCode=" + hashCode +
        //   "&appCode=Tourism" +
        //   "&callbackUrl=" ;
      }
    },

    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },
  },
  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>